import webstore from '../../assests/images/webstore.jpg'
import sourcing from '../../assests/images/sourcing.jpg'
import research from '../../assests/images/research.jpg'
import { motion } from "framer-motion";

const items = [
  {
    title: "Insight & Gift Strategy",
    image: research,
  },
  {
    title: "Global Sourcing & Fulfilment",
    image: sourcing,
  },
  {
    title: "Custom Webstores & E-Commerce",
    image: webstore,
  },
];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export default function CapabilitiesSection() {
  return (
    <section className="py-16 bg-white">
      <motion.h3
        className="text-center px-8 mb-10 text-xl md:p-0 md:text-3xl font-semibold text-gray-900 leading-tight"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        A seamless gifting experience — from idea to delivery.
      </motion.h3>

      <motion.div
        className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-4"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {items.map((item, i) => (
          <motion.div
            key={i}
            className="text-center"
            variants={cardVariants}
          >
            <img
              src={item.image}
              alt={item.title}
              className="rounded-lg mb-4"
            />
            <h4 className="font-semibold">{item.title}</h4>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}

